/*
 * NG+ Double Pack builder.
 *
 * Every cart line is a real bundle product at its own price:
 *   pack      -> "NG+ DoublePack" variant for (Mouthguard 1 color, Mouthguard 2 color)
 *   pack_with -> "NG+ DoublePack (Lanyard Version)" variant, same colors, built from
 *                the lanyard-version mouthguards (hole for the lanyard, own SKUs)
 *   addon     -> "DoublePack Lanyards" variant for the lanyard color (two lanyards, one color)
 * Without lanyards adds the pack line. With lanyards adds pack_with + addon in ONE
 * /cart/add request. Checkout expands each bundle line into component SKUs.
 * No discount rules are involved; prices come straight from the variants.
 *
 * Markup + data (variant maps) live in sections/ng-doublepack-builder.liquid.
 */
(function () {
  'use strict';

  function parseJSON(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function money(cents) {
    return '$' + ((Number(cents) || 0) / 100).toFixed(2);
  }

  function route(root, attr, fallback) {
    return root.dataset[attr] || (window.routes && window.routes[fallback]) || '/' + fallback.replace('_url', '');
  }

  // Dawn's cart-notification / cart-drawer both expose getSectionsToRender()
  // and renderContents(); reuse them so the add feels like a normal add-to-cart.
  function cartTarget() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function init(root) {
    if (root.dataset.ngDpReady) return;
    root.dataset.ngDpReady = '1';

    var packVariants = parseJSON(root.querySelector('[data-ng-dp-pack-variants]'), {});
    var packWithVariants = parseJSON(root.querySelector('[data-ng-dp-pack-with-variants]'), {});
    var addonVariants = parseJSON(root.querySelector('[data-ng-dp-addon-variants]'), {});
    var colorImages = parseJSON(root.querySelector('[data-ng-dp-color-images]'), {});
    var hasAddon = Object.keys(addonVariants).length > 0 && Object.keys(packWithVariants).length > 0;
    var pairs = Array.prototype.slice.call(root.querySelectorAll('[data-ng-dp-pair]'));

    var hero = root.querySelector('[data-ng-dp-hero]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ng-dp-thumb]'));
    var lanyardGroup = root.querySelector('[data-ng-dp-lanyard-group]');
    var lanyardChip = root.querySelector('[data-ng-dp-lanyard-chip]');
    var priceBlock = root.querySelector('[data-ng-dp-price-block]');
    var priceEl = root.querySelector('[data-ng-dp-price]');
    var compareEl = root.querySelector('[data-ng-dp-compare]');
    var salePriceEl = root.querySelector('[data-ng-dp-sale-price]');
    var note = root.querySelector('[data-ng-dp-note]');
    var addButton = root.querySelector('[data-ng-dp-add]');
    var addText = root.querySelector('[data-ng-dp-add-text]');
    var spinner = addButton ? addButton.querySelector('.loading__spinner') : null;
    var status = root.querySelector('[data-ng-dp-status]');

    function mode() {
      if (!hasAddon) return 'without';
      var input = root.querySelector('[data-ng-dp-mode]:checked');
      return input && input.value === 'with' ? 'with' : 'without';
    }

    function checkedValue(scope, role) {
      var input = scope.querySelector('[data-ng-dp-' + role + ']:checked');
      return input ? input.value : '';
    }

    function setUnavailable(input, unavailable) {
      input.classList.toggle('disabled', unavailable);
    }

    // Grey out any color that has no purchasable pack variant given the other pick.
    function markPackAvailability(currentMode, c1, c2) {
      var map = currentMode === 'with' ? packWithVariants : packVariants;
      pairs[0].querySelectorAll('[data-ng-dp-guard]').forEach(function (input) {
        var v = map[input.value + '|' + c2];
        setUnavailable(input, !v || !v.available);
      });
      pairs[1].querySelectorAll('[data-ng-dp-guard]').forEach(function (input) {
        var v = map[c1 + '|' + input.value];
        setUnavailable(input, !v || !v.available);
      });
      if (lanyardGroup) {
        lanyardGroup.querySelectorAll('[data-ng-dp-lanyard]').forEach(function (input) {
          var v = addonVariants[input.value];
          setUnavailable(input, !v || !v.available);
        });
      }
    }

    function updatePairCard(pair, color) {
      var thumb = pair.querySelector('[data-ng-dp-pair-thumb]');
      if (thumb && colorImages[color]) {
        thumb.src = colorImages[color];
        thumb.alt = color + ' NeuroGuard+';
      }
      var picked = pair.querySelector('[data-ng-dp-pair-picked]');
      if (picked) picked.textContent = color + ' mouthguard';
    }

    function updateMedia(currentMode) {
      if (hero) {
        var next = currentMode === 'with' ? hero.dataset.ngDpImageWith : hero.dataset.ngDpImageWithout;
        if (next && hero.getAttribute('src') !== next) hero.setAttribute('src', next);
      }
      thumbs.forEach(function (thumb) {
        if (thumb.dataset.ngDpThumb === currentMode) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function update() {
      var currentMode = mode();
      updateMedia(currentMode);
      if (lanyardGroup) lanyardGroup.hidden = currentMode !== 'with';

      var c1 = pairs[0] ? checkedValue(pairs[0], 'guard') : '';
      var c2 = pairs[1] ? checkedValue(pairs[1], 'guard') : '';
      var lanyard = lanyardGroup ? checkedValue(lanyardGroup, 'lanyard') : '';
      if (pairs[0]) updatePairCard(pairs[0], c1);
      if (pairs[1]) updatePairCard(pairs[1], c2);
      if (lanyardChip) {
        var lanyardInput = lanyardGroup && lanyardGroup.querySelector('[data-ng-dp-lanyard]:checked');
        lanyardChip.style.setProperty('--ng-dp-swatch', (lanyardInput && lanyardInput.dataset.ngDpColor) || '#1f1f21');
      }
      markPackAvailability(currentMode, c1, c2);

      var lines = [];
      var problem = '';
      // With lanyards uses the lanyard-version mouthguard pack (different SKUs).
      var pack = (currentMode === 'with' ? packWithVariants : packVariants)[c1 + '|' + c2];
      if (!pack) {
        problem = 'That color combination is not offered.';
      } else if (!pack.available) {
        problem = c1 + ' + ' + c2 + ' is sold out right now.';
      } else {
        lines.push(pack);
      }
      if (currentMode === 'with' && !problem) {
        var addon = addonVariants[lanyard];
        if (!addon) {
          problem = 'Pick a lanyard color.';
        } else if (!addon.available) {
          problem = lanyard + ' lanyards are sold out right now.';
        } else {
          lines.push(addon);
        }
      }

      // Selection line for the sticky add-to-cart bar (snippets/ng-sticky-atc.liquid).
      root.setAttribute('data-ng-sticky-summary', c1 + ' + ' + c2 + (currentMode === 'with' ? ' · ' + lanyard + ' lanyards' : ' · No lanyards'));

      var total = lines.reduce(function (sum, v) {
        return sum + v.price;
      }, 0);
      var compare = lines.reduce(function (sum, v) {
        return sum + (v.compare > v.price ? v.compare : v.price);
      }, 0);
      var onSale = !problem && compare > total;

      if (priceBlock) priceBlock.classList.toggle('price--on-sale', onSale);
      if (priceEl) priceEl.textContent = money(total);
      if (compareEl) compareEl.textContent = money(compare);
      if (salePriceEl) salePriceEl.textContent = money(total);

      if (note) {
        note.textContent = problem;
        note.hidden = !problem;
      }
      if (addButton) {
        addButton.disabled = !!problem;
        if (addText) addText.textContent = problem ? 'Choose an available combination' : 'Add to cart — ' + money(total);
      }

      return { mode: currentMode, lines: lines, problem: problem };
    }

    function setBusy(busy) {
      if (!addButton) return;
      addButton.setAttribute('aria-disabled', busy ? 'true' : 'false');
      addButton.classList.toggle('loading', busy);
      if (spinner) spinner.classList.toggle('hidden', !busy);
    }

    function showStatus(message, isError) {
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('ng-dp__status--error', !!isError);
    }

    function add() {
      if (!addButton || addButton.getAttribute('aria-disabled') === 'true') return;
      var state = update();
      if (state.problem) return;

      var target = cartTarget();
      var body = {
        items: state.lines.map(function (v) {
          return { id: v.id, quantity: 1 };
        }),
      };
      if (target && typeof target.getSectionsToRender === 'function') {
        body.sections = target
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',');
        body.sections_url = window.location.pathname;
      }

      setBusy(true);
      showStatus('Adding to your cart…', false);

      fetch(route(root, 'ngDpAddUrl', 'cart_add_url'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status && response.status !== 200) {
            throw new Error(response.description || response.message || 'Could not add to cart.');
          }

          showStatus(state.mode === 'with' ? '✓ DoublePack and lanyards added to your cart.' : '✓ DoublePack added to your cart.', false);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ng-doublepack-builder', cartData: response });
          }

          var first = (response.items || [])[0];
          if (target && typeof target.renderContents === 'function' && response.sections && first) {
            // Dawn keys the notification off `key` (notification) / `id` (drawer).
            target.renderContents({ key: first.key, id: first.id, sections: response.sections });
            if (typeof target.setActiveElement === 'function') target.setActiveElement(addButton);
          } else {
            window.location.href = route(root, 'ngDpCartUrl', 'cart_url');
          }
        })
        .catch(function (error) {
          showStatus(error.message || 'Could not add to cart. Please try again.', true);
        })
        .then(function () {
          setBusy(false);
        });
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-ng-dp-mode], [data-ng-dp-guard], [data-ng-dp-lanyard]')) update();
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var input = root.querySelector('[data-ng-dp-mode][value="' + thumb.dataset.ngDpThumb + '"]');
        if (input && !input.checked) {
          input.checked = true;
          update();
        }
      });
    });
    if (addButton) addButton.addEventListener('click', add);

    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ng-dp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor re-renders the section on setting changes.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
